<template>
  <button
    class="language-toggle"
    @click="toggleLanguage"
    :title="$t('language.switch_to')"
  >
    <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"></path>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.6 9h16.8M3.6 15h16.8"></path>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z"></path>
    </svg>
    <span class="language-label">{{ currentLanguageLabel }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { getCurrentLanguage, switchLanguage } from "../i18n"

const currentLanguageLabel = computed(() => {
  const current = getCurrentLanguage()
  return current === "no" ? "NO" : "EN"
})

function toggleLanguage() {
  const current = getCurrentLanguage()
  const newLanguage = current === "no" ? "en" : "no"
  switchLanguage(newLanguage)
}
</script>

